const isDomainMatch = (alias, baseUrl) => {
  try {
    const aliasUrl = new URL(alias.startsWith('https') ? alias : `https://${alias}`);
    const aliasHost = aliasUrl.hostname;
    const { hostname } = baseUrl;

    return aliasHost === hostname || aliasHost.endsWith(`.${hostname}`);
  } catch {
    return false;
  }
};

export default isDomainMatch;
